var NameManager = function() {
    this.names = {};
};

NameManager.prototype.getProposal = function(prefix, prop) {
    if (!prefix) prefix = "";
    if (!this.names[prefix]) this.names[prefix] = {};
    
    var result;
    if (prop) {
        if (!this.names[prefix][prop]) {
            result = prop;
        } else if(!isNaN(parseInt(prop)) && Number.isInteger(Number(prop))){
            var index = parseInt(prop);
            while (this.names[prefix][index]) index++;
            result = index;
        } else {
            var index = 1;
            while (this.names[prefix][prop+index]) index++;
            result = prop+index;
        }
    } else {
        var index = 1;
        while (this.names[prefix][index]) index++;
        result = index;
    }

    return result.toString();
};

NameManager.prototype.register = function(prefix, name) {
    if (name == null) return;
    if (!prefix) prefix = "";
    if (!this.names[prefix]) this.names[prefix] = {};
    if (!this.names[prefix][name]) this.names[prefix][name] = 0;
    this.names[prefix][name]++;
};

NameManager.prototype.remove = function(prefix, name) {
    if (name == null) return;
    if (!prefix) prefix = "";
    if (this.names[prefix] && this.names[prefix][name]) this.names[prefix][name]--;
};

NameManager.prototype.isRegistered = function(prefix, name) {
    if (name == null) return false;
    if (!prefix) prefix = "";
    return !!(this.names[prefix] && this.names[prefix][name]);
};

NameManager.prototype.empty = function() {
    this.names = {};
};

module.exports.NameManager = NameManager;


/*
 * Use as follows:
 * var nameManagedType = new lib_core.NameManager.NameManagedType(this.root.nameManager, "pad_names").validator
 * this.name = this.value("name", null, false, true, nameManagedType.validator);
 * nameManagedType.attachNameManagerHandlers(this.name);
 * this.name(nameManagedType.getProposal(name));
 */
// var NameManagedType = function(nameManager, prefix, nonUnique) {
//     this.nameManager = nameManager;
//     this.prefix = prefix;
//
//     if(nonUnique){
//         this.validator = this._nonUniqueValidator.bind(this);
//     }else{
//         this.validator = this._uniqueValidator.bind(this);
//     }
// };
// NameManagedType.prototype.parser = null;
// NameManagedType.prototype._uniqueValidator = function (val, old) {
//     if(val === old)
//         return true;
//     if(!this.nameManager.isRegistered(this.prefix, val)) {
//         if(old) this.nameManager.remove(this.prefix, old);
//         this.nameManager.register(this.prefix, val);
//         return true;
//     } else {
//         return false;
//     }
// };
//
// NameManagedType.prototype._nonUniqueValidator = function (value, old) {
//     if(value === old)
//         return true;
//         if(old) this.nameManager.remove("term_names", old);
//         this.nameManager.register("term_names", value);
//         return true;
// };
//
// NameManagedType.prototype.attachNameManagerHandlers = function(member) {
//     var self = this;
//     var onDieHandler;
//     if(member.getType() === "value") {
//         onDieHandler = function() {
//             self.nameManager.remove(self.prefix, member());
//         };
//     } else {
//         member.onRemove("remove_name_managed_value_"+member._name(), function (m, idx, value) {
//             self.nameManager.remove(self.prefix, value);
//         }, 10);
//         onDieHandler = function() {
//             member.forEach(function(idx, value) {
//                 self.nameManager.remove(self.prefix, value);
//             });
//         };
//     }
//     member.getTreeNode().onDie("kill_name_managed_value_"+member, onDieHandler, 1);
// };
// NameManagedType.prototype.getProposal = function(arg) {
//     return this.nameManager.getProposal(this.prefix, arg);
// };
// NameManager.NameManagedType = NameManagedType;
